import React from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import { IcoPadlockOpen, IcoPadlockClosed } from '@icons';

const StepThree = ({ aggregate, projects, selectedProjects }) => {
	return (
		<>
			<Row className="flex-column content-step-modal w-100 ms-0">
				<Col className="col-10 ps-0">
					<span className="content-title">Riepilogo delle informazioni</span>
				</Col>

				<Col className="col-10 mt-4 p-3" style={{ backgroundColor: '#DEE4F1', borderRadius: '8px' }}>
					<Row className="px-2 py-3">
						<Col className="col-3 recap-title">Nome gruppo</Col>
						<Col className="col-9 recap-content">{aggregate.name}</Col>
					</Row>

					<Row className="px-2 pb-3">
						<Col className="col-3 recap-title">Descrizione</Col>
						<Col className="col-9 recap-content">{aggregate.description === '' ? '-' : aggregate.description}</Col>
					</Row>

					<Row className="px-2 pb-3">
						<Col className="col-3 recap-title">Accesso</Col>
						<Col className="col-9">
							<Badge
								pill
								bg="info"
								style={{ width: '90px', height: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
							>
								{aggregate.public ? (
									<>
										<span className="badge-text">Pubblico</span>
										<IcoPadlockOpen className="ico-path-fill-white ms-2" height={13} />
									</>
								) : (
									<>
										<span className="badge-text">Privato</span>
										<IcoPadlockClosed className="ico-path-fill-white ms-2" height={13} />
									</>
								)}
							</Badge>
						</Col>
					</Row>

					<Row className="px-2 pb-3">
						<Col className="col-3 recap-title">Progetti aggregati</Col>
						<Col className="col-9 recap-content">
							{projects
								.filter((project) => selectedProjects.includes(project.id))
								.map((project, idx, arr) => (
									<span key={project.id} className="d-inline-block mb-2 me-3">
										{project.name}
									</span>
								))}
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};
export default StepThree;
